import React, { Component } from 'react';
import { connect } from 'react-redux';
import OwlCarousel from 'react-owl-carousel2';
import axios from 'axios';
import Layout from '../layout/Layout';
import Callusnow from './Callusnow';

import $ from 'jquery';  
import Loader from 'react-loader-spinner';
import Slider from "react-slick";

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Reaptcha from 'reaptcha';
toast.configure(); 

var fs = require('browserify-fs');
const API_URL = process.env.REACT_APP_API_URL;
const IMAGE_URL = process.env.REACT_APP_SITE_IMAGE_URL;
function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
       onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
       onClick={onClick}
    />
  );
}
class Takeapledge extends Component {
	
	constructor(props) {
        super(props);
 
        this.state = {
          
            fields: {},
			errors: {},
			languagedata:[],
			defaultlang:6,
			Takeapledges:[],
			statelist:[],
			AllProgrammesCount:0,
			AllCityCount:0,
			AllStateCount:0,
			loaded: true,
			verified: false
			
			
        };
		
		

	    this.handleChange = this.handleChange.bind(this);
		this.submitdonateform = this.submitdonateform.bind(this);

    }

    onVerify = recaptchaResponse => {
    this.setState({
      verified: true
    });
  };


    componentDidMount() {
    	$('html, body').animate({
		scrollTop:0
		}, 1000);
	  	
	}

	 componentWillMount() {
    	
	  	const DefaultLang = localStorage.getItem('DefaultLanguage');
	    this.setState({defaultlang: DefaultLang});
		this.getStatedata(DefaultLang);
		this.gettakeapledgedata(DefaultLang);
	this.getlanguage(DefaultLang);
    
  }

getStatedata(defaultlang){
    
   
    axios.post(`${API_URL}/getstate`, { LanguageId:defaultlang})
        
        .then(res => {
       
          if(res.data.Status == 1)
          {
            const statelist = res.data.ResponseData;
             this.setState({ statelist }); 
          }else{
          	this.setState({ statelist:[] }); 
          }
          })
        
        
        
}
getlanguage(defaultlang){
    
   
    axios.post(`${API_URL}/langfile`, { LangId:defaultlang})
        
        .then(res => {
       
          if(res.data.Status == 1)
          {
            const language = res.data.ResponseData;
            let data = res.data.ResponseData[0];
           
             const mythis=this;
             this.setState({ language }); 

              this.setState({languagedata: data});
             
           
                     
            
          }
          })
        
        
        
}
	gettakeapledgedata(DefaultLang){
		
			axios.post(`${API_URL}/gettakeapledge`, { LanguageId:DefaultLang})
			.then(res => {
				console.log(res);
				if(res.data.Status == 1) 
				{
					const Takeapledges = res.data.ResponseData.Takeapledge;
					const AllProgrammesCount = res.data.ResponseData.TotalProgrammes;
					const AllCityCount = res.data.ResponseData.TotalCity;
					const AllStateCount = res.data.ResponseData.TotalState;
					this.setState({ Takeapledges });
					this.setState({ AllProgrammesCount });
					this.setState({ AllCityCount });
					this.setState({ AllStateCount });
					
				
				}else{
					
					this.setState({ Takeapledges:[] });
					this.setState({ AllProgrammesCount : 0 });
					this.setState({ AllCityCount : 0 });
					this.setState({ AllStateCount : 0 });


				}
				
				this.setState({ loaded: false });


			  })
	}	
	
	handleChange(e) {
      let fields = this.state.fields;
      fields[e.target.name] = e.target.value;
      this.setState({
        fields
      });

    }
    submitdonateform(e) {
	
      e.preventDefault();
      if (this.validateForm()) {
          
         
		 axios.post(`${API_URL}/takeapledge`, {
		 LanguageID:6,		
		 name: this.state.fields.name,
		 email:this.state.fields.email,
		 phone:this.state.fields.phone,
		 city:this.state.fields.city,
		 province:this.state.fields.province,
		 message:this.state.fields.message,
		 })
		  .then(res => {

        this.setState({ errorMessage: res.data.Message,status_code:res.data.Status});
		

		   toast.success(res.data.Message, {position: toast.POSITION.TOP_RIGHT, autoClose: 2000 });

        if(res.data.Status != 0){
       
        this.setState({fields : { name:'', email:'', phone:'', city:'', province:'', message:''} });
      }



       this.setState({
        verified: false
      });


       
	 
		  })
		  
      }else{
      	$('html, body').animate({
		scrollTop:$("#Address_title_scroll").offset().top-100
		}, 1000);
      }

 }
 validateForm() {

      let fields = this.state.fields;
      let errors = {};
      let formIsValid = true;

      if (!fields["name"]) {
        formIsValid = false;
        errors["name"] = "Please enter full name.";
      }

      if (typeof fields["name"] !== "undefined") {
        if (!fields["name"].match(/^[a-zA-Z ]*$/)) {
          formIsValid = false;
          errors["name"] = "Please enter alphabet characters only.";
        }
      }
	  
	  
	  if (!fields["email"]) {
        formIsValid = false;
        errors["email"] = "Please enter email-ID.";
      }

      if (typeof fields["email"] !== "undefined") {
        //regular expression for email validation
        var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
        if (!pattern.test(fields["email"])) {
          formIsValid = false;
          errors["email"] = "Please enter valid email-ID.";
        }
      }
	  
	  
	   
      if (!fields["phone"]) {
        formIsValid = false;
        errors["phone"] = "Enter phone no.";
      }

      if (typeof fields["phone"] !== "undefined") {
        if (!fields["phone"].match(/^[0-9]{10}$/)) {
          formIsValid = false;
          errors["phone"] = "Enter valid phone no.";
        }
      }
      if (!fields["city"]) {
        formIsValid = false;
        errors["city"] = "Please enter City.";
      }
      if (!fields["province"]) {
        formIsValid = false;
        errors["province"] = "Please enter State / Province / Region.";
      }
      if (!fields["message"]) {
        formIsValid = false;
        errors["message"] = "Please enter Message.";
      }
      
       if(this.state.verified==false){
	  	 formIsValid = false;
        errors["captcha"] = "Please Select Reaptcha.";
		}


      this.setState({
        errors: errors
      });
      return formIsValid;


    }

	
	
  render() {
	 
		const settings = {
	      dots: false,
	      infinite: true,
	      autoplay:true,
	      autoplaySpeed:10000,
	      slidesToShow: 2,
	      slidesToScroll: 2,
	      vertical: true,
	      animateOut: 'slideOutUp',
  		  animateIn: 'slideInUp',
  		  nextArrow: <SampleNextArrow />,
      	  prevArrow: <SamplePrevArrow />
	    };



    return (
      <div className="App">
      <Layout languagedata={this.state.languagedata}>

       {this.state.loaded == true ? (	  
		 
	<div className="divloader"> 
		 <Loader 
			 type="ThreeDots"
			 color="#00BFFF"
			 height="100"	
			 width="100"
		  />		  
	 </div>
	
	) : '' }


      
      <section className="banner inner_banner">
		  <div className="bd-example">
		    <div id="carouselExampleCaptions" className="carousel slide" data-ride="carousel">
		      <div className="carousel-inner">
		        <div className="carousel-item active">
		          <img src={ IMAGE_URL+'/images/Pledge-banner.jpg' } className="d-block w-100" alt={"Swacch Bharat - "+this.state.languagedata.take_a_pledge} />
		          <div className="carousel-caption d-none d-md-block">
		            <h1>{this.state.languagedata.take_a_pledge}</h1>
		          </div>
		        </div>
		      </div>
		    </div>
		  </div>
		</section>



		<section className="contact_us Donate_form new-pledges-form">
			<div className="container">
				<div className="row">


				<div className="col-xl-8 col-lg-8 col-md-8">
		        <form className="form-horizontal has-validation-callback" onSubmit= {this.submitdonateform}>
		          <div className="row">
		          	<div className="col-12">
				      <aside className="Address_title" id="Address_title_scroll">{this.state.languagedata.take_a_pledge}</aside>
				    </div>
		            <div className="col-xl-6 col-lg-6 col-md-6">
		              <div className="form-group">
		                <label for="name">
		                  {this.state.languagedata.Name}</label><span className="errorMsg">*</span>
		                <input type="text"
		                 name="name"
		                 id="name"
		                 autoComplete="off"
		                  className={this.state.errors.name ? "form-control error_class" : "form-control"}
				         placeholder={this.state.errors.name ? this.state.errors.name : ""}
		                     onChange={this.handleChange}
		                      value={this.state.fields.name}
		                       />
		               
		              </div>
		            </div>
		            <div className="col-xl-6 col-lg-6 col-md-6">  
		              <div className="form-group">
		                <label for="email">
		                  {this.state.languagedata.Email_Address}</label><span className="errorMsg">*</span>
		                
		                  <input type="email"
		                   name="email"
		                   id="email"
		                   autoComplete="off"
		                    className={this.state.errors.email ? "form-control error_class" : "form-control"}
				         placeholder={this.state.errors.email ? this.state.errors.email : ""}
		                        onChange={this.handleChange}
		                          value={this.state.fields.email} 
		                          />
		              
		                
		              </div>
		            </div>
		            				  
				  <div className="col-xl-4 col-lg-4 col-md-4">
				    <div className="form-group">
				      <label for="phone">
				        {this.state.languagedata.Phone}</label><span className="errorMsg">*</span>
				      <input type="text"
				       name="phone"
				       id="phone"
				       autoComplete="off"
				        className={this.state.errors.phone ? "form-control error_class" : "form-control"}
				         placeholder={this.state.errors.phone ? this.state.errors.phone : ""}
				          onChange={this.handleChange}
				           value={this.state.fields.phone} 
				           />
				     
				    </div>
				  </div>
				  
				  <div className="col-xl-4 col-lg-4 col-md-4">
				    <div className="form-group">
				      <label for="province">
				      {this.state.languagedata.State_Province_Region}</label><span className="errorMsg">*</span>
				      <select name="province"
				      id="province"
				       className={this.state.errors.province ? "form-control error_class" : "form-control"}
				        onChange={this.handleChange}
				         value={this.state.fields.province} >
							<option value="">Select State</option>
							{this.state.statelist.map((item) => 
								<option value={item.StateName}>{item.StateName}</option>
							)} 
							</select>
				      
				 
				    </div>
				  </div>
				  <div className="col-xl-4 col-lg-4 col-md-4">
				    <div className="form-group">
				      <label for="city">
				        {this.state.languagedata.City}</label><span className="errorMsg">*</span>
				      <input type="text"
				       name="city"
				       id="city"
				       autoComplete="off"
				         className={this.state.errors.city ? "form-control error_class" : "form-control"}
				         placeholder={this.state.errors.city ? this.state.errors.city : ""}
				          onChange={this.handleChange}
				            value={this.state.fields.city} 
				            />
				  
				    </div>
				  </div>
				  
		           
		            <div className="col-12">
		              <div className="form-group">
		                <label for="message">
		                 {this.state.languagedata.Message} <span className="errorMsg">*(Min 120 Characters )</span></label>
		                <textarea 

		                id="message"
		                 className={this.state.errors.message ? "form-control error_class Take-a-Pledge-message" : "form-control Take-a-Pledge-message"}
				         placeholder={this.state.errors.message ? this.state.errors.message : ""}


		                 name="message"
		                 
		                   onChange={this.handleChange}
		                    value={this.state.fields.message}
		                     rows="4" maxLength="120"></textarea>
		                
		              </div>
		            </div>


	<div className="col-12 text-left">
		<Reaptcha sitekey="6LdP6-EUAAAAAOUXIJ7-MRV73C_LwXO98dy8cMJX" onVerify={this.onVerify} />
		<div className="text-danger">{this.state.errors.captcha}</div>
    </div>



		            <div className="col-md-12">
		              <button type="submit" className="btn btn-primary pull-right" id="btnContactUs">
		                Submit</button>
		               
		            </div>
		          </div>
		        </form>
		        </div>


		<div className="col-xl-4 col-lg-4 col-md-4">
			{ this.state.Takeapledges.length>0 ? 
				 <Slider {...settings}>
				{ this.state.Takeapledges.map((item) => 
					<div className="item">
						<div className="new-pledges-taken">
						<p>{item.TakeapledgeMessage} </p>
						<span>{item.TakeapledgeName}</span>
						<div>{item.TakeapledgeCity}</div>
						</div>
					</div>
				)}
			</Slider> : "" }
		</div>
</div>
</div> 
</section>

		<section className="programe_two">
<div className="container">
<div className="row">
<div className="col-12">
<h2>{this.state.languagedata.our_impact}</h2>
</div>
</div>
<div className="row">
<div className="col-xl-4 col-lg-4 col-md-4">
<div className="program_box">
<aside>Projects</aside>
<span>{this.state.AllProgrammesCount}</span>
	<p>Class aptent taciti sociosqu ad litora torquent per conubia nostra</p>
</div>
</div>
<div className="col-xl-4 col-lg-4 col-md-4">
<div className="program_box">
<aside>Cities</aside>
<span>{this.state.AllCityCount}</span>
	<p>Class aptent taciti sociosqu ad litora torquent per conubia nostra</p>
</div>
</div>
<div className="col-xl-4 col-lg-4 col-md-4">
<div className="program_box">
<aside>State</aside>
<span>{this.state.AllStateCount}</span>
	<p>Class aptent taciti sociosqu ad litora torquent per conubia nostra</p>
</div>
</div>
</div>
</div>
</section>
		<Callusnow languagedata={this.state.languagedata} />
		</Layout>
	  </div>
    );
  }
}

export default Takeapledge;



// WEBPACK FOOTER //
// ./src/component/Takeapledge.js